import Api from './Api'
import ApiAuth from './ApiAuth'

export const Plans = {
    plans(context) {
        return new Promise((resolve, reject) => {
            Api().get('/plans').then(response => {
                context.commit('setPlans', response.data);
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        })
    },
    planInfo(context, id) {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`/plan/${id}`).then(response => {
                context.commit('setPlanInfo', response.data);
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        })
    },
    availablePlans(context) {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`/available_plans`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        })
    }
};